export default __webpack_public_path__ + "6f6028e65f624f74600b3e70e5d5b7a8.png";